import { AutogenModelOrderPayablesProfileLookup, AutogenRowOrderPayablesProfileLookup } from "./autogen/AutogenModelOrderPayablesProfileLookup";

export class ModelOrderPayablesProfileLookup extends AutogenModelOrderPayablesProfileLookup<RowOrderPayablesProfileLookup> {
	constructor() {
		super(RowOrderPayablesProfileLookup);
	}
}

export class RowOrderPayablesProfileLookup extends AutogenRowOrderPayablesProfileLookup {
}